import React, { Component } from "react";
import Modal from "../../../UIComponents/CustomModal/Modal";
import { Popup } from "semantic-ui-react";
import { toast } from "react-toastify";

import { ReactComponent as PositiveSentiment } from "../../../../assets/svg/positive-sentiment.svg";
import { ReactComponent as NegativeSentiment } from "../../../../assets/svg/negative-sentiment.svg";
import { ReactComponent as NeutralSentiment } from "../../../../assets/svg/neutral-sentiment.svg";

import "./CommentModal.scss";

class CommentModal extends Component {
    constructor(props) {
        super(props);
        this.isResearch = this.props.dashboardPageType === "research";
    }

    renderSentimentTooltip(id) {
        return (
            <div className="tooltip-contents">
                <PositiveSentiment className="sentiment-icon" onClick={() => this.changeSentiment(id, "POSITIVE")} />
                <NeutralSentiment className="sentiment-icon" onClick={() => this.changeSentiment(id, "NEUTRAL")} />
                <NegativeSentiment className="sentiment-icon" onClick={() => this.changeSentiment(id, "NEGATIVE")} />
            </div>
        );
    }

    changeSentiment(id, sentiment) {
        if (this.isResearch) {
            toast.error("This functionality is not available on Search page.");
            return;
        }

        let commentIndex = this.props.comments.findIndex((elem) => elem._id === id);
        if (commentIndex > -1) {
            // let comments = [];
            // this.props.comments.forEach((element) => {
            //     comments.push(element);
            // });
            // comments[commentIndex].postSentiment = sentiment;
            this.props.setCommentSentiment(sentiment, commentIndex);
        } else {
            this.props.setPostSentiment(sentiment);
        }
    }

    renderSentiment(sentiment, id) {
        const getSentimentIcon = () => {
            if (sentiment === "positive") return <PositiveSentiment title={sentiment} className="sentiment-icon" />;
            else if (sentiment === "negative") return <NegativeSentiment title={sentiment} className="sentiment-icon" />;
            else return <NeutralSentiment title={sentiment} className="sentiment-icon" />;
        };

        return (
            <Popup
                trigger={getSentimentIcon()}
                content={this.renderSentimentTooltip(id)}
                on="click"
                className="sentiment-change-tooltip skiptranslate"
                position="top right"
                hideOnScroll
                style={{ zIndex: "1000000" }}
            />
        );
    }

    render() {
        let userTimezone = JSON.parse(localStorage.getItem("company")).user_timezone_name;
        return (
            <Modal className="comments-modal" show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>CONVERSATION THREAD</Modal.Header>
                <Modal.Content noSkipGTranslate={true}>
                    <div style={{ display: "flex" }}>
                        {this.props.postInfo && this.props.postInfo.postImg && this.props.postInfo.postImg !== "" && (
                            <img className="post-image" src={this.props.postInfo.postImg} />
                        )}
                        <section className="content">
                            {this.props.postInfo && (
                                <div className="header skiptranslate">
                                    <img className="author-image" src={this.props.postInfo.postAuthorImg} />
                                    <span className="post-author skiptranslate"> {this.props.postInfo.postAuthor} </span>
                                    <span className="post-time skiptranslate">
                                        {this.props.postInfo.postTime && this.props.postInfo.postTime[1]} {userTimezone}{" "}
                                    </span>
                                    {this.props.postInfo.postSentiment &&
                                        this.renderSentiment(this.props.postInfo.postSentiment.toLowerCase(), this.props.postInfo._id)}
                                </div>
                            )}
                            {this.props.postInfo && (
                                <div className="post-content">
                                    <p className="content"> {this.props.postInfo.post} </p>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <a className="view-more skiptranslate" target="_blank" rel="noreferrer" href={this.props.postInfo.postLink}>
                                            VIEW MORE
                                        </a>
                                        <div>
                                            {!this.props.commentsLoading && this.props.comments && this.props.comments.length > 0 && (
                                                <span className="download_csv" onClick={() => this.props.downloadParentPostCsv()}>
                                                    Download CSV
                                                </span>
                                            )}
                                            {this.props.commentsLoading && <span className="comments-count"> Loading ... </span>}
                                            {!this.props.commentsLoading && this.props.comments && this.props.comments.length !== undefined && (
                                                <span className="comments-count"> {this.props.comments.length} Comments </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </section>
                    </div>
                    {this.props.commentsLoading && <span className="info skiptranslate"> Loading comments </span>}

                    {!this.props.commentsLoading && this.props.comments && this.props.comments.length === 0 && (
                        <span className="info skiptranslate"> Comments haven&apos;t been pulled for this post yet. </span>
                    )}
                    <div className="comments">
                        {!this.props.commentsLoading &&
                            this.props.comments &&
                            this.props.comments.length > 0 &&
                            this.props.comments.map((post, i) => (
                                <div className="comment" key={i}>
                                    <div className="header skiptranslate">
                                        {post.postAuthorImg && post.postAuthorImg !== "" && <img className="author-image" src={post.postAuthorImg} />}
                                        <span className="post-author"> {post.postAuthor} </span>
                                        <span className="post-time"> {post.postTime && post.postTime[1]} </span>
                                        {this.renderSentiment(post.postSentiment.toLowerCase(), post._id)}
                                    </div>
                                    <div className="post-content">
                                        <p className="content"> {post.post} </p>
                                    </div>
                                </div>
                            ))}
                    </div>
                </Modal.Content>
            </Modal>
        );
    }
}

export default CommentModal;
